// extracted by mini-css-extract-plugin
module.exports = {"accountNavButton":"Bt","menuBackground":"Bu","navArrow":"Bv","avatar":"Bw","userName":"Bx","active":"By","b":"Bz","a":"BA"};